import { HelperText } from '~/components/helper-text'
import {
  InputHelperText,
  InputTextActions,
  InputTextButton,
  InputTextField,
  InputTextIcon,
  InputTextLabel,
} from './components'
import { InputTextProvider } from './contexts/input-text-context'
import type { IInputTextProps } from './types'

import { Children, isValidElement } from 'react'
import { isDEV, logger } from '~/utils'
import { useInputTextProps } from './hooks'
import * as Comp from './text-input.styles'
import { SCOPE_WARNING_MESSAGE } from './utils/const'

const InputTextRoot = ({
  children,
  size = 'md',
  full,
  disabled = false,
  readonly = false,
  hasError = false,
  errorText = 'Dados inválidos',
  value = '',
  onChangeText,
  testID = 'inputTest',
  ...props
}: IInputTextProps) => {
  const { isActive, setIsActive } = useInputTextProps()

  const renderInternalComponents = Children.map(children, child => {
    if (!isValidElement(child)) return

    if (
      child.type === InputTextLabel ||
      child.type === InputTextActions ||
      child.type === InputHelperText
    ) {
      return child
    }

    if (isDEV()) {
      logger.warning(SCOPE_WARNING_MESSAGE)
      return
    }
  })

  const componentProperties = {
    size,
    full,
    hasError,
    errorText,
    disabled,
    readonly,
    value,
    onChangeText,
    isActive,
    setIsActive,
    testID,
  } as const

  return (
    <InputTextProvider {...componentProperties}>
      <Comp.Root {...props} testID={testID}>
        {renderInternalComponents}
        {hasError && (
          <HelperText
            disabled={disabled}
            readonly={readonly}
            hasError={hasError}
            withIcon={true}
            iconName={'rdicon-warning-circle'}
            iconSize="tiny"
          >
            {errorText}
          </HelperText>
        )}
      </Comp.Root>
    </InputTextProvider>
  )
}

export const InputText = {
  Root: InputTextRoot,
  Field: InputTextField,
  Label: InputTextLabel,
  Actions: InputTextActions,
  Icon: InputTextIcon,
  Button: InputTextButton,
  HelperText: InputHelperText,
}

export type { IInputTextProps }
